<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="accordion mt-3" id="accordionExample">
          <div class="card card-body domain-card">
            <div class="media">
              <button class="btn btn-sm btn-primary mr-4 collapse-btn" data-toggle="collapse" :data-target="'#collapse_outage'" :aria-controls="'collapse_outage'"><i class="fa fa-plus"></i></button>

              <div  class="media-body">
                <div class="domain-head">
                  <h5 class="mt-1 h5-m0">
                    Preset Replies for Outages
                  </h5>
                </div>
              </div>
            </div>
            <div :id="'collapse_outage'" class="collapse" data-parent="#accordionExample">
              <div class="card-body">
                <outagePresets :preset-macros="presetMacros"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="accordion mt-3" id="accordionExample">
          <div class="card card-body domain-card">
            <div class="media">
              <button class="btn btn-sm btn-primary mr-4 collapse-btn" data-toggle="collapse" :data-target="'#collapse_migrtion'" :aria-controls="'collapse_migrtion'"><i class="fa fa-plus"></i></button>

              <div  class="media-body">
                <div class="domain-head">
                  <h5 class="mt-1 h5-m0">
                    Preset Replies for Migration
                   </h5>
                </div>
              </div>
            </div>
            <div :id="'collapse_migrtion'" class="collapse" data-parent="#accordionExample">
              <migration-presets :preset-macros="presetMigrationMacros"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="accordion mt-3" id="accordionExample">
          <div class="card card-body domain-card">
            <div class="media">
              <button class="btn btn-sm btn-primary mr-4 collapse-btn" data-toggle="collapse" :data-target="'#collapse_traffic'" :aria-controls="'collapse_traffic'"><i class="fa fa-plus"></i></button>

              <div  class="media-body">
                <div class="domain-head">
                  <h5 class="mt-1 h5-m0">
                    Preset Replies for Traffic
                   </h5>
                </div>
              </div>
            </div>
            <div :id="'collapse_traffic'" class="collapse" data-parent="#accordionExample">
              <trafficPresets :preset-macros="presetTraffic"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="accordion mt-3" id="accordionExample">
          <div class="card card-body domain-card">
            <div class="media">
              <button class="btn btn-sm btn-primary mr-4 collapse-btn" data-toggle="collapse" :data-target="'#collapse_ticket'" :aria-controls="'collapse_ticket'"><i class="fa fa-plus"></i></button>

              <div  class="media-body">
                <div class="domain-head">
                  <h5 class="mt-1 h5-m0">
                    Preset Replies for Domain's Ticket
                   </h5>
                </div>
              </div>
            </div>
            <div :id="'collapse_ticket'" class="collapse" data-parent="#accordionExample">
              <ticketPresets :preset-macros="presetTickets"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="accordion mt-3" id="accordionExample">
          <div class="card card-body domain-card">
            <div class="media">
              <button class="btn btn-sm btn-primary mr-4 collapse-btn" data-toggle="collapse" :data-target="'#collapse_chat'" :aria-controls="'collapse_chat'"><i class="fa fa-plus"></i></button>

              <div  class="media-body">
                <div class="domain-head">
                  <h5 class="mt-1 h5-m0">
                    Preset Replies for Text Messages
                   </h5>
                </div>
              </div>
            </div>
            <div :id="'collapse_chat'" class="collapse" data-parent="#accordionExample">
              <chat-presets :preset-macros="presetChat"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init"
import draggable from "vuedraggable";
import outagePresets from './outagesPresets'
import MigrationPresets from "./migrationPresets";
import trafficPresets from "./trafficPresets";
import ticketPresets from './../Presets/ticket'
import chatPresets from './../Presets/chat'


export default {
  name: "predefinedResponse",
  components: {
    trafficPresets,
    MigrationPresets,
    draggable,
    outagePresets,
    ticketPresets,
    chatPresets
  },
  data () {
    return {
      loading: false,
      presetMacros: [],
      presetMigrationMacros: [],
      presetTraffic: [],
      presetTickets: [],
      presetChat: []
    }
  },
  mounted() {
    this.getReplies()
  },
  methods: {
    async getReplies(){
      this.loading=true
      this.presetMacros=[]
      this.presetMigrationMacros=[]
      this.presetTraffic=[]
      let result=await db.collection("permissions")
          .doc("preset_macros_outages")
          .get();
      if(result.exists){
        this.presetMacros = result.data().replies;
      }
      const macros = await db
          .collection("permissions")
          .doc("preset_macros")
          .get();
      const ref = await db
          .collection("permissions")
          .doc("preset_macros_traffic")
          .get();
      if(ref.exists){
        this.presetTraffic= ref.data().replies
      }
      const ticketRef = await db
          .collection("permissions")
          .doc("preset_macros_domain")
          .get();
      if(ticketRef.exists){
        this.presetTickets= ticketRef.data().replies
      }
      this.presetMigrationMacros = macros.data().replies;
      const chatRef = await db
          .collection("permissions")
          .doc("preset_macros_chat")
          .get();
      if(chatRef.exists){
        this.presetChat= chatRef.data().replies
      }
      console.log(this.presetMacros, this.presetMigrationMacros)
      this.loading=false

    },

  }
}
</script>

<style scoped>
.row.macro {
  padding: 10px;
  margin-bottom: 2px;
  border: 1px solid #9b9696;
}
.task-container{
  padding: 1.5em;
}
.cf-status-icons {
i {
  font-size: 25px;

&.disabled {
   color: #7E7E7E;
 }

&.enabled {
   color: #47f260;
 }

&.yellow {
   color: #f2b61d;
 }
}
}
.click-to-copy{
  margin: 0 !important;
  padding: 7px !important;
}
.domain-card{
  background: #f0f0f4;
  box-shadow: none;
  border-radius: 8px !important;
&:hover{
   box-shadow: 0 6px 10px 3px rgba(0, 0, 0, 0.15);;
 }
.collapse-btn{
  margin-top: 0.5rem !important;
}
.domain-head{
  display: flex;
  justify-content: space-between;
.h5-m0 {
  margin: 0;
}
.ul-m0{
  margin: 0;
}
}
.domain-info{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
.badge{
  text-transform: none !important;
}
}
}
.bl-bt{
  display: flex;
  align-items: flex-end;
button {
  margin: 0 !important;
}
}
.cursor-pointer{
  cursor: pointer;
}
pre{
  display: inline-block;
  margin-bottom: 0px;
}
</style>
